import { render, staticRenderFns } from "./evaluationStaffSignUp.vue?vue&type=template&id=19627961&scoped=true"
import script from "./evaluationStaffSignUp.vue?vue&type=script&lang=js"
export * from "./evaluationStaffSignUp.vue?vue&type=script&lang=js"
import style0 from "./evaluationStaffSignUp.vue?vue&type=style&index=0&id=19627961&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19627961",
  null
  
)

export default component.exports